import React from 'react';
import { useUser } from '@/store/hooks';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

interface RoleBasedPageProps {
  memberComponent: React.ComponentType;
  adminComponent: React.ComponentType;
  staffComponent?: React.ComponentType;
}

const RoleBasedPage: React.FC<RoleBasedPageProps> = ({
  memberComponent: MemberComponent,
  adminComponent: AdminComponent,
  staffComponent: StaffComponent
}) => {
  const user = useUser();

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" text="Loading..." />
      </div>
    );
  }

  // Route to appropriate component based on user role
  switch (user.role) {
    case 'member':
      return <MemberComponent />;
    
    case 'universal_admin':
    case 'office_admin':
      return <AdminComponent />;
    
    case 'department_head':
    case 'front_worker':
    case 'staff':
    case 'committee_member':
      return StaffComponent ? <StaffComponent /> : <AdminComponent />;
    
    default:
      return <MemberComponent />;
  }
};

export default RoleBasedPage;

